import {filter} from "lodash"

import authentication from "@irati/auth"

const myComments = (item) => {
  const comments = filter(item.comments.results, (test) => test.createdBy.uuid === authentication.user().uuid)

  if (!Array.isArray(comments) || comments.length === 0) {
    return []
  }

  return comments
}

export default myComments
